<style lang="less">
  @import "./RealName.less";
</style>

<template>
  <div class="real-name">
    <!--part 1-->
    <div class="real-name-info" v-if="progress===1">
      <div>
        <p class="clear"><label>ICCID号：</label><span>{{nowIccid || '当前设备未插入SIM卡'}}</span></p>
        <p class="clear"><label>真实姓名：</label><input v-model="realName" type="text" maxlength="15" placeholder="请输入真实姓名"></p>
        <p class="clear"><label>身份证号：</label><input v-model="idCard" type="text" maxlength="18" placeholder="请输入身份证号码"></p>
      </div>
      <!--按钮-->
      <van-button class="long-btn margin-tb-b" type="info" size="large" @click="nextStepFn">下一步</van-button>
      <!--ios怎么会唤醒途云APP?-->
      <!--<p>点击“下一步”即视为同意<a href="http://ys.spreadwin.cn/index.php/Home/Authentication/auth_desc.html">《实名认证协议》</a></p>-->
      <p>点击“下一步”即视为同意<span @click="toLinkFn">《实名认证协议》</span></p>
    </div>
    <!--part 2-->
    <div class="real-name-file" v-if="progress===2">
      <div>
        <h4>手持身份证照（请参照样式）</h4>
        <div class="clear">
          <van-uploader :before-read="beforeRead" :max-count="1">
            <img v-if="!handCardFile" src="../../../assets/images/real/ic_add.png" alt="">
            <p v-if="handCardFile">已选择：{{handCardFile.name.length>30?handCardFile.name.substring(0,30) + '...':handCardFile.name}}</p>
          </van-uploader>
          <img src="../../../assets/images/real/img_card01.png" alt="">
        </div>
        <p class="clear"><label>证件需保持字清晰可见</label><label>样式</label></p>
      </div>
      <div>
        <h4>身份证正面（请参照样式）</h4>
        <div class="clear">
          <van-uploader :before-read="beforeReadFront" :max-count="1">
            <img v-if="!frontCardFile" src="../../../assets/images/real/ic_add.png" alt="">
            <p v-if="frontCardFile">已选择：{{frontCardFile.name.length>30?frontCardFile.name.substring(0,30) + '...':frontCardFile.name}}</p>
          </van-uploader>
          <img src="../../../assets/images/real/img_card02.png" alt="">
        </div>
        <p class="clear"><label>证件需保持字清晰可见</label><label>样式</label></p>
      </div>
      <div>
        <h4>身份证反面（请参照样式）</h4>
        <div class="clear">
          <van-uploader :before-read="beforeReadBack" :max-count="1">
            <img v-if="!backCardFile" src="../../../assets/images/real/ic_add.png" alt="">
            <p v-if="backCardFile">已选择：{{backCardFile.name.length>30?backCardFile.name.substring(0,30) + '...':backCardFile.name}}</p>
          </van-uploader>
          <img src="../../../assets/images/real/img_card03.png" alt="">
        </div>
        <p class="clear"><label>证件需保持字清晰可见</label><label>样式</label></p>
      </div>
      <!--<p>提交认证即视为同意<a href="http://ys.spreadwin.com/index.php/Home/Authentication/auth_desc.html">《实名认证协议》</a></p>-->
      <van-button class="long-btn margin-t" plain type="info" size="large" @click="prevStepFn">上一步</van-button>
      <van-button class="long-btn margin-tb" type="info" size="large" :loading="loadingSubmit" loading-text="提交中..." @click="realNameCheckFn">提交认证</van-button>
    </div>
    <!--part 3-->
    <div class="real-name-result" v-if="progress===3">
      <div>
        <!--<img src="../../../assets/images/real/ic_result02.png" alt="">-->
        <img class="real-name-result-tj" src="../../../assets/images/real/ic_result01.png" alt="">
        <h3>实名认证已提交，请耐心等待审核</h3>
        <p class="clear"><label>真实姓名</label><span>{{realName || 'XXX'}}</span></p>
        <p class="clear"><label>身份证号</label><span>{{idCard || 'XXX'}}</span></p>
        <p class="clear"><label>ICCID号</label><span>{{nowIccid || 'XXX'}}</span></p>
      </div>
    </div>
    <!--part 4-->
    <div class="real-name-result" v-if="progress===4">
      <div>
        <img src="../../../assets/images/real/ic_result02.png" alt="">
        <h3 class="green-color">恭喜您，您已通过实名认证</h3>
        <p class="clear"><label>真实姓名</label><span>{{realName || 'XXX'}}</span></p>
        <p class="clear"><label>身份证号</label><span>{{idCard || 'XXX'}}</span></p>
        <p class="clear"><label>ICCID号</label><span>{{nowIccid || 'XXX'}}</span></p>
      </div>
    </div>
    <!--part 5-->
    <div class="real-name-result" v-if="progress===5">
      <div>
        <img src="../../../assets/images/real/ic_result03.png" alt="">
        <h3 class="red-color">实名认证失败</h3>
        <div><p>请重新拍摄照片并按要求提交。本次实名认证失败原因：{{notPassText || '未知'}}</p></div>
      </div>
      <div class="re-submit">
        <van-button class="long-btn margin-tb-b" type="info" size="large" @click="resubmitFn">重新提交</van-button>
      </div>
    </div>
    <!--part 6-->
    <div class="real-name-result" v-if="progress===6">
      <div>
        <img src="../../../assets/images/real/ic_result04.png" alt="">
        <h3 class="red-color">非途云卡</h3>
        <div><p>此卡（{{nowIccid}}）为非途云卡，暂不支持非途云卡进行实名认证</p></div>
      </div>
      <div class="re-submit">
        <van-button class="long-btn margin-tb-b" type="info" size="large" @click="toHomePageFn">返回首页</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import RealName from './RealName.js'
export default {
  ...RealName
}
</script>
